export const titleCase = (s: string) => {
  const v = (s || '').trim();
  if (!v) return v;
  return v
    .replace(/[_-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
};


